import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('holidays-calendar', {
    props: ['client'],

    components: {
        datePicker
    },

    data () {
        return {
            filters: {
                from: moment().startOf('year').format("DD-MM-YYYY"),
                to: moment().endOf('year').format("DD-MM-YYYY"),
            },

            admins: [],

            holidaydata: [],

            holidaytype: [],

            date: {
                start: '',
                end: ''
            },

            loading: false,

            holiday: null,

            deleting: false,

            completing: false,

            alert: null,

            tpOptions: {
                format: 'DD-MM-YYYY',
            },

            createForm: $.extend(true, new Form({
                data: {
                    admin: '',
                    start: moment().format('DD-MM-YYYY'),
                    end: moment().format('DD-MM-YYYY'),
                    time: 'Full Day',
                    type: '',
                    bd_trip: '',
                    bd_trip_date: ''
                }
            }), {}),

            holidays: {}

        };
    },

    mounted () {
        moment().utcOffset(0, true).format();
        this.filters.client = this.client;

        let defaultView = (localStorage.getItem("fcDefaultView") !== null ? localStorage.getItem("fcDefaultView") : "timeGridWeek");

        this.calendar = new Calendar(document.getElementById('holidays-calendar'), {
            plugins: [
                interactionPlugin,
                dayGridPlugin,
                timeGridPlugin,
                listPlugin
            ],

            header: {
                left: 'prev,next today',
                center: 'title',
                // right: 'listMonth,timeGridWeek,timeGridDay'
                right: 'dayGridMonth,listMonth'
            },

            defaultView: 'dayGridMonth',

            navLinks: true,

            displayEventTime : false,

            editable: true,

            events: this.getHolidays,

            eventClick: this.getEvent,

            eventDrop: this.calendarEvent,

            eventRender (info) {
                if (info.event.extendedProps.imageurl) {
                    $(info.el).find("div.fc-content").prepend("<img src='" + info.event.extendedProps.imageurl +"' width='9' height='18'>");
                }
            },

            /* eventResize: this.calendarEvent,

            viewSkeletonRender (view, element) {
                localStorage.setItem("fcDefaultView", view.view.type);
            }, */

            dateClick: this.create
        });

        this.calendar.render();

        $('#create').on('hidden.bs.modal', () => {
            this.createForm.data.start = '';
            this.createForm.data.end = '';
            this.alert = null;
        });

        $('#holiday').on('hidden.bs.modal', () => {
            this.loading = false;
            this.completing = false;
            this.deleting = false;

            this.alert = null;
        });
    },

    methods: {
        getHolidays(e) {
            this.loading = true;
            this.holidays = {};
            
            return axios.get('/api/holiday', {

                params: {
                    ...this.filters
                }
                
            }).then((response) => {
                this.loading = false;
                let events = [];
                // Set colour from options - Holiday Types.
                let type = [];
                type = JSON.parse(response.data.holidaytype);

                this.admins = response.data.admins;

                for (let event of response.data.holidays) {
                    let color = '#ff4d4d';
                    let full_name = event.first_name + ' ' + event.last_name;
                    let start_date = event.start_date;
                    let end_date = event.end_date;
                    // Set time period images.
                    let time_period = '/images/time-full.gif';
                    switch (event.time) {
                        case 'AM':
                            time_period = '/images/time-am.gif';
                            break;
                        case 'PM':
                            time_period = '/images/time-pm.gif';
                            break;
                    }
                    
                    type.forEach(function(value) {
                        if(event.type == value.value){
                            color = value.colour;
                        }
                    });

                    events.push({
                        ...event,
                        start: start_date.substr(0, 10),
                        end: end_date.substr(0, 10) + ' 23:59:59',
                        title: full_name,
                        imageurl: time_period,
                        backgroundColor: color,
                        borderColor: color
                    });
                }
                return events;
            });
        },

        filterEvents () {
            this.calendar.refetchEvents();
        },

        create (e) {
            console.log('create');
            let start = moment(e.date);
            if (localStorage.getItem("fcDefaultView") === 'dayGridMonth') {
                let now = moment();
                start.set({
                    hour: now.get('hour'),
                    minute: now.get('minute'),
                    second: now.get('second'),
                });
            }
            let end = moment(start).add(1, 'hour');
            this.createForm.data.start = start;
            this.createForm.data.end = end;
            $('#create').modal('show');
        },

        store () {
            console.log('store');
            Http.post('/api/holiday/create/', this.createForm).then(response => {
                this.getHolidays();
                console.log(response);
                this.createForm.resetForm();
                this.calendar.refetchEvents();
                $('#create').modal('hide');
            });
        },

        calendarEvent(e) {
            axios.post('/api/holiday/update_dates/' + e.event.id, {
                id: e.event.id,
                start: moment(e.event.start).format('YYYY-MM-DD HH:mm:ss'),
                end: moment(e.event.end).format('YYYY-MM-DD HH:mm:ss')
            });
        },

        getEvent (e) {
            console.log('event');
            this.loading = true;
            $('#holiday').modal('show');
            console.log(e.event.id);
            axios.get('/api/holiday/edit/' + e.event.id).then(response => {
                console.log(response);
                this.holiday = response.data;
                this.holiday.start = moment(response.data.start, "YYYY-MM-DD HH:mm:ssZ");
                this.holiday.end = moment(response.data.end, "YYYY-MM-DD HH:mm:ssZ");
                this.loading = false;
            });
        },

        deleteHoliday () {
            console.log('delete');
            axios.post('/api/holiday/delete/' + this.holiday.id).then(response => {
                $('#holiday').modal('hide');
                this.calendar.refetchEvents();
            });
        },

        async update () {
            console.log('update');
            axios.post('/api/holiday/update/', this.holiday).then(response => {
                console.log(response);
                //if (this.alert === null) {
                    this.calendar.refetchEvents();
                    $('#holiday').modal('hide');
                //}
            });
        },

    }
});